enum SyncType {
  /** Uses the 5-minute sync cache. */
  Manual,
  /** Uses the 15-minute sync cache. */
  Auto,
  /** Bypasses the sync cache entirely. */
  BypassCache,
}

export default SyncType;
